import { AmberHoc, AmberHocProps } from '../../../util';
import {
  CreateBinStoragePeriodMutationVariables as Variables,
  // BinStoragePeriodFragmentFragment as Result,
  // GetGrainBinStoragePeriodQuery,
  // GetGrainBinStoragePeriodQueryVariables,
  // GetGrainBinStoragePeriodDocument,
  withCreateBinStoragePeriod as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

type Result = {
  grain_bin_storage_cycle_id: number;
  grain_bin_id: number;
  storage_cycle_name: string;
  grain_type: string;
  start_epoch: Date;
  end_epoch?: Date | null;
  created_at: Date;
};

export type WithCreateBinStoragePeriodHocChildProps = {
  /// TODO: update return type
  createBinStoragePeriod: (variables: Variables) => any;
};
export const withCreateBinStoragePeriodHoc: AmberHoc<
  {},
  WithCreateBinStoragePeriodHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithCreateBinStoragePeriodHocChildProps, typeof component>,
    WithCreateBinStoragePeriodHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        createBinStoragePeriod: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
              const { createBinStoragePeriod: result } = data;
              if (!result) {
                return;
              }
              console.log('Successfully mutated data with results: ', result);
              // proxy.writeQuery<GetGrainBinStoragePeriodQuery, GetGrainBinStoragePeriodQueryVariables>({
              //   query: GetGrainBinStoragePeriodDocument,
              //   data: { __typename: 'Query', latest_grain_bin_events: result },
              //   variables: { grain_bin_id: variables.grain_bin_id },
              // });
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.createBinStoragePeriod || [];
        },
      };
    },
  })(component as any);
